import { IconName, IconPrefix } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon, FontAwesomeIconProps,  } from "@fortawesome/react-fontawesome"

import { ComponentType, FC, Suspense } from "react";
import { createLazyLoadedIconComponent, IconProps } from ".";
import { faSquare, faXmarkHexagon } from "@fortawesome/pro-duotone-svg-icons";
import { useErrorBoundary, withErrorBoundary } from "react-use-error-boundary";
import { styled } from "@mui/material";



const IconMapping: Record<IconPrefix, ComponentType<IconProps> | undefined> = {
    fab: createLazyLoadedIconComponent('fab'), // brand
    fad: createLazyLoadedIconComponent('fad'), // duotone solid
    fadl: createLazyLoadedIconComponent('fadl'), // duotone light
    fadr: createLazyLoadedIconComponent('fadr'), // duotone regular
    fadt: createLazyLoadedIconComponent('fadt'), // duotone thin
    fak: undefined, // UNKNOWN?!?!?
    fakd: undefined, // UNKNOWN?!?!?!
    fal: createLazyLoadedIconComponent('fal'), // light
    far: createLazyLoadedIconComponent('far'), // regular
    fas: createLazyLoadedIconComponent('fas'), // solid
    fasdl: createLazyLoadedIconComponent('fasdl'), // sharp duotone light
    fasdr: createLazyLoadedIconComponent('fasdr'), // sharp duotone regular
    fasds: createLazyLoadedIconComponent('fasds'), // sharp duotone solid,
    fasdt: createLazyLoadedIconComponent('fasdt'), // sharp duotone thin
    fasl: createLazyLoadedIconComponent('fasl'), //sharp light
    fasr: createLazyLoadedIconComponent('fasr'), //sharp regular
    fass: createLazyLoadedIconComponent('fass'), // sharp solid
    fast: createLazyLoadedIconComponent('fast'), // sharp thin
    fat: createLazyLoadedIconComponent('fat'), // thin
}

const ErrorIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.palette.error.main
}))

const Icon: FC<FontAwesomeIconProps> = withErrorBoundary(({ icon, ... rest }) => {
    
    const [error] = useErrorBoundary();

    if (error) {
        return (
            <ErrorIcon 
                icon={faXmarkHexagon}
                {...rest}
            />
        )
    }

    let prefix: IconPrefix | undefined = undefined;
    let iconName: IconName | undefined = undefined;
    let map = false;

    if (icon && icon instanceof Array && icon.length === 2) {
        prefix = icon[0];
        iconName = icon[1];
        map = true;
    }
    else if (icon && icon instanceof Object && (icon as any).icon === undefined) {
        prefix = icon.prefix;
        iconName = icon.iconName;
        map = true;
    }
    else if (icon?.constructor === String) {
        prefix = 'fas';
        iconName = icon;
        map = true;
    }

    if (!map || !prefix || !iconName) {
        return (
            <FontAwesomeIcon icon={icon} {...rest} />
        )
    }

    const Component = IconMapping[prefix];

    if (!Component) {
        return (
            <FontAwesomeIcon icon={icon} {...rest} />
        )
    }



    return (
        <Suspense
            fallback={
                <FontAwesomeIcon 
                    icon={faSquare}
                    {...rest}
                    fade
                />
            }
        >
            <Component
                icon={{
                    iconName: iconName,
                    prefix: prefix
                }}
                {...rest}
            />
        </Suspense>
    )
})

export default Icon;